import cc from "classcat"

export default function Stats({ facts, theme = "light" }) {
  return (
    <div
      className={cc([
        "overflow-hidden py-12 lg:py-20",
        theme === "light" && "bg-white",
        theme === "green" && "bg-kkm-green",
        theme === "dark" && "bg-transparent",
      ])}
    >
      <div className="mx-auto max-w-2xl justify-between gap-6 space-y-8 px-4 sm:flex sm:space-y-0 sm:px-6 lg:mx-auto lg:max-w-7xl lg:px-8">
        {facts.map((f, index) => (
          <div
            key={index}
            className={cc([
              "flex max-w-xl flex-col justify-center space-y-1 border-l-8 pl-3 lg:mx-0 lg:max-w-none",
              theme === "light" && "border-kkm-green",
              theme === "green" && "border-white",
              theme === "dark" && "border-zinc-500",
            ])}
          >
            <div
              className={cc([
                "font-display text-2xl leading-tight",
                theme === "light" && "text-zinc-600",
                theme === "green" && "text-zinc-50",
                theme === "dark" && "text-zinc-100",
              ])}
            >
              {f.line1}
            </div>
            <div
              className={cc([
                "text-base leading-tight",
                (theme === "light" || theme === "green") && "text-zinc-800",
                theme === "dark" && "text-zinc-400",
              ])}
            >
              {f.line2}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
